"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var mobx_1 = require("mobx");
var Types_1 = require("@CommonFrontendBackend/Folders/Types");
var Types_2 = require("Common/AssetLibrary/ImageLibrary/Types");
var ImageLibraryDataStore_1 = require("Common/AssetLibrary/ImageLibrary/ImageLibraryDataStore");
var ResourceTypes_1 = require("@CommonFrontendBackend/Resources/ResourceTypes");
var AbstractSystemFolderDataStore_1 = require("Common/AssetLibrary/ImageLibrary/SystemFolderStores/AbstractSystemFolderDataStore");
var ImageLibraryUtils_1 = require("Common/AssetLibrary/ImageLibrary/ImageLibraryUtils");
var AssetFetchingError_1 = __importDefault(require("Common/AssetLibrary/Error/AssetFetchingError"));
var ImageCdnHelper_1 = require("@CommonFrontendBackend/Utils/ImageCdnHelper");
var UploadsDataStore = (function (_super) {
    __extends(UploadsDataStore, _super);
    function UploadsDataStore(uploadsService, imageResourceApiService, disableImgix) {
        var _this = _super.call(this) || this;
        _this.uploadsService = uploadsService;
        _this.imageResourceApiService = imageResourceApiService;
        _this.disableImgix = disableImgix;
        _this.systemFolderId = Types_2.ImageLibrarySystemFolder.Uploads;
        return _this;
    }
    UploadsDataStore.prototype.searchImages = function (searchTerm, pageNumber, folderId) {
        if (pageNumber === void 0) { pageNumber = 0; }
        return __awaiter(this, void 0, Promise, function () {
            var uploadedImageData, e_1, formattedNewImages;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, this.uploadsService.getImages(pageNumber, ImageLibraryDataStore_1.IMAGES_PER_PAGE, searchTerm, folderId)];
                    case 1:
                        uploadedImageData = _a.sent();
                        return [3, 3];
                    case 2:
                        e_1 = _a.sent();
                        throw new AssetFetchingError_1.default("Unable to fetch uploaded images!");
                    case 3:
                        if (uploadedImageData.length < ImageLibraryDataStore_1.IMAGES_PER_PAGE) {
                            this.isServiceOutOfNewData = true;
                        }
                        formattedNewImages = uploadedImageData.map(function (data) { return ({
                            thumbnailUrl: _this.getThumbnailUrl(data.url),
                            url: data.url,
                            id: data.id,
                            name: data.name,
                        }); });
                        this.currentImages = (0, lodash_1.uniqBy)(__spreadArray(__spreadArray([], __read(this.currentImages), false), __read(formattedNewImages), false), "id");
                        return [2];
                }
            });
        });
    };
    UploadsDataStore.prototype.fetchImages = function (pageNumber, folderId) {
        if (pageNumber === void 0) { pageNumber = 0; }
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.searchImages("", pageNumber, folderId)];
                    case 1: return [2, _a.sent()];
                }
            });
        });
    };
    UploadsDataStore.prototype.moveImages = function (imageIds, folderId) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (folderId === Types_2.ImageLibrarySystemFolder.Uploads) {
                            folderId = null;
                        }
                        return [4, this.imageResourceApiService.moveResources(folderId, imageIds.map(function (imageId) {
                                return {
                                    type: ResourceTypes_1.DashboardResourceType.UploadedImage,
                                    id: imageId,
                                };
                            }))];
                    case 1:
                        _a.sent();
                        this.removeImages(imageIds);
                        return [2];
                }
            });
        });
    };
    UploadsDataStore.prototype.renameImage = function (imageId, newName) {
        return __awaiter(this, void 0, Promise, function () {
            var renamedImageIndex, image;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.uploadsService.updateImage(imageId, { name: newName })];
                    case 1:
                        _a.sent();
                        renamedImageIndex = this.currentImages.findIndex(function (data) { return data.id === imageId; });
                        if (this.currentImages[renamedImageIndex]) {
                            image = this.currentImages[renamedImageIndex];
                            if ((0, ImageLibraryUtils_1.isUploadedImage)(image)) {
                                image.name = newName;
                            }
                        }
                        return [2];
                }
            });
        });
    };
    UploadsDataStore.prototype.deleteImage = function (imageId) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.uploadsService.deleteImage(imageId)];
                    case 1:
                        _a.sent();
                        this.removeImages([imageId]);
                        return [2];
                }
            });
        });
    };
    UploadsDataStore.prototype.bulkDeleteImages = function (imageIds) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.uploadsService.deleteMultipleImages(imageIds)];
                    case 1:
                        _a.sent();
                        this.removeImages(imageIds);
                        return [2];
                }
            });
        });
    };
    UploadsDataStore.prototype.removeImages = function (imageIds) {
        this.currentImages = this.currentImages.filter(function (data) { return !(0, lodash_1.includes)(imageIds, data.id); });
    };
    UploadsDataStore.prototype.getThumbnailUrl = function (url) {
        if (this.disableImgix) {
            return url;
        }
        else {
            return (0, ImageCdnHelper_1.getImageSrc)(url, this.disableImgix, { maxWidth: 744 });
        }
    };
    var _a, _b, _c, _d, _e;
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, Object, typeof (_a = typeof Types_1.ImageLibraryFolderId !== "undefined" && Types_1.ImageLibraryFolderId) === "function" ? _a : Object]),
        __metadata("design:returntype", typeof (_b = typeof Promise !== "undefined" && Promise) === "function" ? _b : Object)
    ], UploadsDataStore.prototype, "searchImages", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, typeof (_c = typeof Types_1.ImageLibraryFolderId !== "undefined" && Types_1.ImageLibraryFolderId) === "function" ? _c : Object]),
        __metadata("design:returntype", typeof (_d = typeof Promise !== "undefined" && Promise) === "function" ? _d : Object)
    ], UploadsDataStore.prototype, "fetchImages", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, String]),
        __metadata("design:returntype", typeof (_e = typeof Promise !== "undefined" && Promise) === "function" ? _e : Object)
    ], UploadsDataStore.prototype, "renameImage", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], UploadsDataStore.prototype, "removeImages", null);
    return UploadsDataStore;
}(AbstractSystemFolderDataStore_1.AbstractSystemFolderDataStore));
exports.default = UploadsDataStore;
